import React from "react";
import { BsCaretDownFill, BsCaretUpFill, BsDash } from "react-icons/bs";

const SortArrow = ({ isSorted, isSortedDesc }) => {
  return isSorted ? (
    isSortedDesc ? (
      <BsCaretDownFill className="table-sorter-icon color-primary" />
    ) : (
      <BsCaretUpFill className="table-sorter-icon color-primary" />
    )
  ) : (
    <BsDash className="table-sorter-icon" />
  );
};

export default SortArrow;
